import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppUpdateService {
  constructor(private readonly http: HttpClient) {}

  unlockUpdate(appId: number): Observable<void> {
    const url = `${environment.urls.MOBILE_API}/app/${appId}/unlock-update`;

    return this.http.get<void>(url);
  }
}
